import PropTypes from 'prop-types';

import { useFormContext, Controller } from 'react-hook-form';

import { Switch, FormControlLabel } from '@mui/material';

RHFSwitch.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool
};

export default function RHFSwitch({ name, disabled, ...other }) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      control={
        <Controller name={name} control={control} render={({ field }) => <Switch disabled={disabled} {...field} checked={field.value} />} />
      }
      disabled={disabled}
      {...other}
    />
  );
}
